import { TimesheetStatus } from '@sdk/timesheets/api/apiTypes';

import EmployeeViewPendingEmployeeConsentBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/employee/EmployeeViewPendingEmployeeConsentBanner';
import ManagerViewPendingEmployeeConsentBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/manager/ManagerViewPendingEmployeeConsentBanner';
import ManagerApprovedBanner from '@web/timesheets/EmployeePendingConsentTimesheetViewModal/components/ModalBanner/ManagerApprovedBanner';

type Props = {
  managerName: string;
  status: TimesheetStatus;
  isManagerView: boolean;
  isAddition: boolean;
};
const ModalBanner = ({ managerName, status, isManagerView, isAddition }: Props) => {
  if (status === TimesheetStatus.approved) {
    return <ManagerApprovedBanner />;
  }

  if (isManagerView) {
    // Banners only managers can see
    if (status === TimesheetStatus.pendingConsent) {
      return <ManagerViewPendingEmployeeConsentBanner />;
    }
  } else {
    // Banners employee can see, and by employee we also mean managers that has direct supervisors.
    // Only managers who don't have supervisiors will see managers path.
    if (status === TimesheetStatus.pendingConsent) {
      return (
        <EmployeeViewPendingEmployeeConsentBanner
          managerName={managerName}
          isAddition={isAddition}
        />
      );
    }
  }

  // Should never reach this state - all the states are handled within various condtions.
  return null;
};

export default ModalBanner;
